import type { IMarket, IOutcomeConsensus } from "~/types/event";

export enum MarketsDataGridField {
  Market = "title",
  Trade = "trade",
  Chance = "chance",
  Price = "price",
  Spread = "spread",
  Liquidity = "liquidity",
  Volume = "volume",
  H24 = "volume24pers",
  D7 = "volume7pers",
  OpenInterest = "openInterest",
  EndsIn = "endDate",
  Status = "unifiedStatus",
}

export interface IMarketsDataGridMarketRow extends IMarket {
  rowType: "market";
  isInGroup: boolean;
}

export interface IMarketsDataGridGroupRow {
  id: string;
  rowType: "group";
  groupedMarkets: IMarket[];
  outcome: IOutcomeConsensus | null;
  outcomeTitle: string | null;
}

export interface IMarketsDataGridNoteRow {
  id: string;
  rowType: "note";
  text: string;
}

export type IMarketsDataGridRow =
  | IMarketsDataGridMarketRow
  | IMarketsDataGridGroupRow
  | IMarketsDataGridNoteRow;

export const isMarketsDataGridGroupRow = (
  row: IMarketsDataGridRow
): row is IMarketsDataGridGroupRow => {
  return row.rowType === "group";
};

export const isMarketsDataGridMarketRow = (
  row: IMarketsDataGridRow
): row is IMarketsDataGridMarketRow => {
  return row.rowType === "market";
};

export const isMarketsDataGridNoteRow = (
  row: IMarketsDataGridRow
): row is IMarketsDataGridNoteRow => {
  return row.rowType === "note";
};
